import appConfig from '@/config/app.config'

/**
 * 项目默认配置项
 *
 */

export default Object.assign({
  appName: '泡芙教育-老师端', // 项目名称配置
  enableMenuPermit: false, // 开启菜单权限校验
  enablePageHeader: false, // 开启页面头部(面包屑)
  ServerAPI: '',
  AMAP_KEY: '50bc57dd9f72732e4dcff303ab1b2bce' // 高德地图
}, appConfig)
